var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Flex, Tag, Typography, theme } from '@robinpowered/ui-kit';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventRsvp } from '../../hooks/useEventRsvp';
import { RSVP, SELECTABLE_RSVP_STATUSES, } from '../../utils/eventRsvp';
import { RsvpCommentModal } from './RsvpCommentModal';
var RSVP_LABEL_KEYS = (_a = {},
    _a[RSVP.ACCEPTED] = 'eventDetails.rsvp.labels.accepted',
    _a[RSVP.DECLINED] = 'eventDetails.rsvp.labels.declined',
    _a[RSVP.TENTATIVE] = 'eventDetails.rsvp.labels.tentative',
    _a);
export var EventRsvpActions = function () {
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _a = useEventRsvp(), canShow = _a.canShow, calendarsLoading = _a.calendarsLoading, currentStatus = _a.currentStatus, submittingStatus = _a.submittingStatus, submitRsvp = _a.submitRsvp;
    var _b = __read(useState(null), 2), pendingStatus = _b[0], setPendingStatus = _b[1];
    var handleSelectStatus = useCallback(function (status) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(status === RSVP.ACCEPTED)) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitRsvp(status, null)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    setPendingStatus(status);
                    return [2 /*return*/];
            }
        });
    }); }, [submitRsvp]);
    var handleCommentSubmit = useCallback(function (comment) { return __awaiter(void 0, void 0, void 0, function () {
        var status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingStatus)
                        return [2 /*return*/];
                    status = pendingStatus;
                    setPendingStatus(null);
                    return [4 /*yield*/, submitRsvp(status, comment)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [pendingStatus, submitRsvp]);
    if (calendarsLoading || !canShow) {
        return null;
    }
    return (_jsxs(RsvpSection, { vertical: true, gap: 8, children: [_jsx(Typography.Text, { strong: true, children: t('eventDetails.rsvp.going') }), _jsx(Flex, { gap: 8, wrap: "wrap", children: SELECTABLE_RSVP_STATUSES.map(function (status) { return (_jsx(RsvpTag, { "$colorInfo": token.colorInfo, "$colorInfoHover": token.colorInfoHover, "$colorBorder": token.colorBorder, checked: currentStatus === status, disabled: !!submittingStatus, onChange: function (checked) {
                        if (checked)
                            void handleSelectStatus(status);
                    }, children: t(RSVP_LABEL_KEYS[status]) }, status)); }) }), _jsx(RsvpCommentModal, { open: pendingStatus !== null, status: pendingStatus, submitting: !!submittingStatus, onSubmit: function (comment) { return void handleCommentSubmit(comment); }, onCancel: function () { return setPendingStatus(null); } })] }));
};
var RsvpSection = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"])));
var RsvpTag = styled(Tag.CheckableTag)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n\n  &:hover:not(.ant-tag-checkable-checked) {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &.ant-tag-checkable-checked {\n    background-color: ", ";\n    border-color: ", ";\n    color: #fff;\n  }\n\n  &.ant-tag-checkable-checked:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n\n  &:hover:not(.ant-tag-checkable-checked) {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &.ant-tag-checkable-checked {\n    background-color: ", ";\n    border-color: ", ";\n    color: #fff;\n  }\n\n  &.ant-tag-checkable-checked:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (_a) {
    var $colorBorder = _a.$colorBorder;
    return $colorBorder;
}, function (_a) {
    var $colorInfoHover = _a.$colorInfoHover;
    return $colorInfoHover;
}, function (_a) {
    var $colorInfo = _a.$colorInfo;
    return $colorInfo;
}, function (_a) {
    var $colorInfo = _a.$colorInfo;
    return $colorInfo;
}, function (_a) {
    var $colorInfo = _a.$colorInfo;
    return $colorInfo;
}, function (_a) {
    var $colorInfoHover = _a.$colorInfoHover;
    return $colorInfoHover;
}, function (_a) {
    var $colorInfoHover = _a.$colorInfoHover;
    return $colorInfoHover;
});
var templateObject_1, templateObject_2;
